import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './routers'
import i18n from './i18n'
import dassDS from 'ds-ui'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import globalFiltersPlugin from './helpers/globalfilters/globalfilters'
import alertPlugin from './helpers/components/Alert'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { loadConfig } from './configs/service'
import Logger from './helpers/logger'

let app
async function startApp() {
  Logger.info('🚀 Iniciando aplicação...')
  try {
    let config = await loadConfig()        
    Logger.info('✅ Config carregada com sucesso:', config)
    app = createApp(App).use(Quasar, quasarUserOptions)
      .use(i18n)
      .use(router)
      .use(store)
      .use(dassDS)
      .use(VueTheMask)
      .use(money)
      .use(globalFiltersPlugin)
      .use(alertPlugin)
      .mount('#app')
    const envLogLevel = config?.LOG_LEVEL || process.env?.LOG_LEVEL || 'INFO'
        Logger.info(`Inicializando logger sac-admin. (Log level: ${envLogLevel})`)
      } catch (error) {
        Logger.error('Erro ao carregar configuração:', error)
      }

  }

startApp()

export { app }